import { useLocation, matchPath } from 'react-router';

import styles from './styles.module.css';
import Tabs from './tabs';
import Breadcrumb from '../Breadcrumb';
import WebSocketIndicator from '../WebSocketIndicator';
import { navigationPaths } from '@/constants/navigationPaths';
import { useNavigationBar } from '@/context/NavigationBarContext';
import { isLocationTurbineBreadcrumb } from '@/utils/turbineNavigation';

const showWebSocketPath = [
  navigationPaths.turbines,
  navigationPaths.locations,
  navigationPaths.locationsDetails
];

export default function NavigationBar() {
  const location = useLocation();
  const { tabsSegment, breadcrumbArray } = useNavigationBar();
  const hasTabs = tabsSegment.length > 0;
  const isLocationTurbineFlow = isLocationTurbineBreadcrumb(breadcrumbArray);

  const socketMatch = showWebSocketPath.some(path =>
    matchPath(path, location.pathname)
  );
  return (
    <div className={styles.headerContainer}>
      <div
        className={`${styles.headerContentLeft} ${hasTabs ? styles.hasTabs : ''} ${isLocationTurbineFlow && hasTabs ? styles.headerContentLeftCompact : ''}`}
      >
        <Breadcrumb />
      </div>
      <div className={styles.headerContentCenter}>
        <Tabs />
      </div>
      <div className={styles.headerContentRight}>
        {socketMatch && <WebSocketIndicator />}
      </div>
    </div>
  );
}
